import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { ScrollService } from '../../../services/scroll.services';
import { RouterLink, NavigationEnd, Router, RouterModule } from "@angular/router";
import { filter } from 'rxjs/operators';


@Component({
  selector: 'app-header',
  imports: [RouterModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  activeSection: string = 'home';
  isScrolled = false;
  constructor(private scrollService: ScrollService, private eRef: ElementRef, private router: Router,) {

   }
   @HostListener('window:scroll', [])
   onWindowScroll() {
     this.isScrolled = window.pageYOffset > 200;
   }
   ngOnInit(): void {
    this.captureRoute();
     
   }
  // scrollToSection(sectionId: string) {
  //   this.activeSection = sectionId;
  //   this.scrollService.scrollTo(sectionId);
  //   const isMobile = window.innerWidth <= 991;
  //   if (isMobile) {
  //     this.toggleMenu(); // Now toggleMenu doesn't need an argument
  //   }
  // }
  captureRoute() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const urlSegments = event.urlAfterRedirects.split('/').filter(Boolean);
        let currentSegment = urlSegments[urlSegments.length - 1];
        this.activeSection=currentSegment;
        console.log('Current segment:', currentSegment);
      });
    
  }

  scrollToSection(route: string) {
    this.activeSection = route;
    this.router.navigate(['/' + route]);  
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const menutoggle = document.querySelector('.menu-toggle');

      if (menutoggle) {
        const isBlock = window.getComputedStyle(menutoggle).display === 'none';
        console.log('Is display block?', isBlock);
        if(!isBlock)
        {
        
          this.toggleMenu();
        }
      }  


  }

  toggleMenu() {
    const ele: any = document.querySelector('.main-navbar'); // only grabs the first match
    ele.classList.toggle('mobilenavbar');
    const element = document.querySelector('.navbar-nav');
    if (element) {
      element.classList.remove('navbar-nav'); // removes the class, element stays
    }
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    const element: any = document.querySelector('.main-navbar'); // Or use id: '#my-id'
    if (element?.classList.contains('mobilenavbar')) {
      const clickedInsideNavLinks = this.eRef.nativeElement.querySelector('.main-navbar')?.contains(event.target as Node);
      const clickedInsideOtherClass = this.eRef.nativeElement.querySelector('.menu-toggle')?.contains(event.target as Node);
      if (!clickedInsideNavLinks && !clickedInsideOtherClass) {
        setTimeout(() => {
          this.toggleMenu();
        }, 50);
      }
    } else {
      console.log('Class does not exist.');
    }
  }
}
